import PropTypes from "prop-types";
import React from "react";
import { frenchDateOnly, numeroPoliceAffichage } from "../../../../variables/functions";
import DuplicataStamp from "./DuplicataStamp";
import { resolveAttestationDriver } from "./attestationDriver";

const formatCategorieLabel = (engin, contrat) => {
    const categorie = engin?.categorie || contrat?.engins?.[0]?.categorie;
    const usage = engin?.usage || contrat?.engins?.[0]?.usage;
    const code = categorie?.codeCategorie || "";

    if (usage === "TPV" || code.toUpperCase().startsWith("TPV")) {
        return "TPV";
    }

    if (categorie?.nom?.toUpperCase()?.startsWith("TRANSPORT")) {
        return `TPV - ${categorie?.codeCategorie}`;
    }

    return categorie?.nom || "";
};

// Décalage vertical global du bloc CEDEAO (calibration sur le formulaire pré-imprimé).
// ↑ diminuer pour remonter, ↓ augmenter pour descendre.
const CEDEAO_TOP_OFFSET = "250px";
// Décalage horizontal global des 3 volets (→ augmenter pour aller à droite).
const CEDEAO_LEFT_OFFSET = "18px";

const AttestationCEDEAOToPrint = React.forwardRef((props, ref) => {
    const categorieLabel = formatCategorieLabel(props.engin, props.contrat);
    const preferSous = props?.preferSouscripteur === undefined ? true : props.preferSouscripteur;
    const driver = resolveAttestationDriver({ contrat: props?.contrat, engin: props?.engin, preferSouscripteur: preferSous });

    return (
        <div ref={ref} className="position-relative" style={{ height: 400, width: 1080 }}>
            <DuplicataStamp contrat={props.contrat} fontSize={28} panels={3} />
            <div className="row">
                <div className="col" style={{ position: 'relative', top: CEDEAO_TOP_OFFSET, left: CEDEAO_LEFT_OFFSET }}>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "30px", marginTop: "45px", fontSize: "12px" }}
                    >
                        <b>
                            {driver.nomComplet.substring(0, 20)}{" "}

                        </b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "30px", marginTop: "60px", fontSize: "12px" }}
                    >
                        <b>{driver.nomComplet.substring(20)} {driver.contact}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "90px", marginTop: "70px", fontSize: "12px" }}
                    >
                        <b>
                            {props.engin?.immatriculation || ""}
                        </b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "85px", marginTop: "90px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.marque || ""}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "62px", marginTop: "105px", fontSize: "12px" }}
                    >
                        <b>{props.contrat?.organisme?.raisonSociale}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "112px", marginTop: "135px", fontSize: "12px" }}
                    >
                        <b>{props.contrat?.producteur?.agence?.nom ? `${props.contrat?.producteur?.agence?.nom} ${props.contrat?.producteur?.agence?.ville}` : "---"}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "46px", marginTop: "155px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.numeroChassis}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "62px", marginTop: "173px", fontSize: "12px" }}
                    >
                        <b>{numeroPoliceAffichage(props.contrat)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "47px", marginTop: "197px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "135px", marginTop: "197px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "35px", marginTop: "237px", fontSize: "12px" }}
                    >
                        <b>{categorieLabel}</b>
                    </h6>
                </div>
                <div className="col" style={{ position: 'relative', top: CEDEAO_TOP_OFFSET, left: CEDEAO_LEFT_OFFSET }}>
                    <h6
                        className=""
                        style={{ position: 'absolute', marginLeft: "-100px", marginTop: "46px", fontSize: "12px" }}
                    >
                        <b>
                            {driver.nomComplet.substring(0, 20)}{" "}
                        </b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-100px", marginTop: "60px", fontSize: "12px" }}
                    >
                        <b>{driver.nomComplet.substring(20)} {driver.contact}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-50px", marginTop: "74px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.immatriculation || ""}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-50px", marginTop: "90px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.marque || "_"}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-70px", marginTop: "109px", fontSize: "12px" }}
                    >
                        <b>{props.contrat?.organisme?.raisonSociale}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-45px", marginTop: "140px", fontSize: "12px" }}
                    >
                        <b>{props.contrat?.producteur?.agence?.nom ? `${props.contrat?.producteur?.agence?.nom} ${props.contrat?.producteur?.agence?.ville}` : "---"}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-95px", marginTop: "155px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.numeroChassis || "---"}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-70px", marginTop: "174px", fontSize: "12px" }}
                    >
                        <b>{numeroPoliceAffichage(props.contrat)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-90px", marginTop: "198px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "5px", marginTop: "197px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-95px", marginTop: "237px", fontSize: "12px" }}
                    >
                        <b>{categorieLabel}</b>
                    </h6>
                </div>
                <div className="col" style={{ position: 'relative', top: CEDEAO_TOP_OFFSET, left: CEDEAO_LEFT_OFFSET }}>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-30px", marginTop: "30px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "94px", marginTop: "30px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-257px", marginTop: "65px", fontSize: "12px" }}
                    >
                        <b>
                            {props.contrat?.souscripteur?.nom || "_"}{" "}
                            {props.contrat?.souscripteur?.prenom || ""}{" "}
                        </b>
                    </h6>
                    <h6 className="text-left" style={{ position: 'absolute', marginLeft: "-257px", marginTop: "80px", fontSize: "12px" }}>
                        <b>
                            {props.contrat?.souscripteur?.adresse || "-"}{" "}
                            {props.contrat?.souscripteur?.contact?.[0] || ""}
                        </b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-180px", marginTop: "110px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.immatriculation || "_"}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-253px", marginTop: "145px", fontSize: "12px" }}
                    >
                        <b>
                            {`${props.contrat?.organisme?.raisonSociale} ${props.contrat?.organisme?.siegeSocial}`.substring(0, 36)}
                        </b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-253px", marginTop: "158px", fontSize: "12px" }}
                    >
                        <b>
                            {`${props.contrat?.organisme?.raisonSociale} ${props.contrat?.organisme?.siegeSocial}`.substring(36)}
                        </b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-210px", marginTop: "232px", fontSize: "12px" }}
                    >
                        <b>{categorieLabel}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "55px", marginTop: "52px", fontSize: "12px" }}
                    >
                        <b>{numeroPoliceAffichage(props.contrat)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "30px", marginTop: "70px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "130px", marginTop: "70px", fontSize: "12px" }}
                    >
                        <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-5px", marginTop: "105px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.marque}</b>
                    </h6>

                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-5px", marginTop: "135px", fontSize: "12px" }}
                    >
                        <b>{props.engin?.numeroChassis}</b>
                    </h6>
                    <h6
                        className="text-left"
                        style={{ position: 'absolute', marginLeft: "-5px", marginTop: "160px", fontSize: "12px" }}
                    >
                        <b>{props.contrat?.producteur?.agence?.nom ? `${props.contrat?.producteur?.agence?.nom} ${props.contrat?.producteur?.agence?.ville}` : "POOL"}</b>
                    </h6>
                </div>
            </div>
        </div >
    );
});
AttestationCEDEAOToPrint.propTypes = {
    contrat: PropTypes.object,
    engin: PropTypes.object,
    printing: PropTypes.bool,
};
AttestationCEDEAOToPrint.displayName = "Attestation Moto";

export default AttestationCEDEAOToPrint;
